import { Component, computed, input } from '@angular/core';

/**
 * Avatar da IA: círculo `--primary` com o logo do RapiDocs em branco, direto na bola. Usado no chat de criação
 * (`ia-chat`), no modo "Editar com IA" do editor e no atalho do feed.
 *
 * `pulse` liga a respiração (a IA está pensando); `prefers-reduced-motion` a desliga.
 */
@Component({
    selector: 'ra-chat-orb',
    template: `
        <span
            class="orb"
            [class.shadow]="withShadow()"
            [class.pulse]="pulse()"
            [style.width.rem]="size() / 16"
            [style.height.rem]="size() / 16">
            <!-- O logo do RapiDocs direto na bola: os dois quadrados em branco e a estrela
                 vazada na cor da bola (sem disco branco por trás). -->
            <svg
                class="logo"
                viewBox="0 0 24 24"
                aria-hidden="true"
                [style.width.rem]="iconSize() / 16"
                [style.height.rem]="iconSize() / 16">
                <rect class="logo-shape" x="1" y="1" width="16.5" height="16.5" rx="4.4" />
                <rect class="logo-shape" x="6" y="6" width="17" height="17" rx="4.6" />
                <path
                    class="logo-star"
                    d="M11.6 6.3 Q12.25 11.15 17.1 11.8 Q12.25 12.45 11.6 17.3 Q10.95 12.45 6.1 11.8 Q10.95 11.15 11.6 6.3 Z" />
            </svg>
        </span>
    `,
    styles: `
        :host {
            display: inline-flex;
            flex: 0 0 auto;
        }

        .orb {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            background: var(--primary);
        }

        .shadow {
            box-shadow: 0 14px 32px color-mix(in srgb, var(--primary) 36%, transparent);
        }

        .pulse {
            animation: orb-pulse 1.4s ease-in-out infinite;
        }

        .logo {
            display: block;
        }

        .logo-shape {
            fill: var(--contentInverse);
        }

        .logo-star {
            fill: var(--primary);
        }

        @keyframes orb-pulse {
            0%,
            100% {
                box-shadow: 0 0 0 0 color-mix(in srgb, var(--primary) 45%, transparent);
            }

            50% {
                box-shadow: 0 0 0 0.375rem color-mix(in srgb, var(--primary) 0%, transparent);
            }
        }

        @media (prefers-reduced-motion: reduce) {
            .pulse {
                animation: none;
            }
        }
    `,
})
export class RaChatOrbComponent {
    public size = input(40);
    public withShadow = input(false);
    /** A IA está trabalhando: o orb respira. */
    public pulse = input(false);

    protected iconSize = computed(() => Math.max(12, Math.round(this.size() * 0.56)));
}
